import _slicedToArray from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["__demoMode"],
  _excluded2 = ["id"],
  _excluded3 = ["id"],
  _excluded4 = ["id", "disabled"];
var _Te;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import G, { Fragment as N, createContext as X, createRef as H, useContext as $, useEffect as q, useMemo as x, useReducer as z, useRef as K } from "react";
import { match as j } from '../../utils/match.js';
import { forwardRefWithAs as h, render as D, Features as Q } from '../../utils/render.js';
import { disposables as _ } from '../../utils/disposables.js';
import { useDisposables as W } from '../../hooks/use-disposables.js';
import { useIsoMorphicEffect as L } from '../../hooks/use-iso-morphic-effect.js';
import { useSyncRefs as F } from '../../hooks/use-sync-refs.js';
import { useId as k } from '../../hooks/use-id.js';
import { Keys as c } from '../keyboard.js';
import { Focus as y, calculateActiveIndex as Y } from '../../utils/calculate-active-index.js';
import { isDisabledReactIssue7711 as Z } from '../../utils/bugs.js';
import { isFocusableElement as ee, FocusableMode as te, sortByDomNode as ne, Focus as V, focusFrom as re, restoreFocusIfNecessary as J } from '../../utils/focus-management.js';
import { useOutsideClick as oe } from '../../hooks/use-outside-click.js';
import { useTreeWalker as ae } from '../../hooks/use-tree-walker.js';
import { useOpenClosed as se, State as C, OpenClosedProvider as ie } from '../../internal/open-closed.js';
import { useResolveButtonType as ue } from '../../hooks/use-resolve-button-type.js';
import { useOwnerDocument as le } from '../../hooks/use-owner.js';
import { useEvent as d } from '../../hooks/use-event.js';
import { useTrackedPointer as pe } from '../../hooks/use-tracked-pointer.js';
import { useTextValue as ce } from '../../hooks/use-text-value.js';
var me = function (r) {
    return r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r;
  }(me || {}),
  de = function (r) {
    return r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r;
  }(de || {}),
  fe = function (a) {
    return a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a;
  }(fe || {});
function w(e) {
  var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (r) {
    return r;
  };
  var r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null,
    i = ne(u(e.items.slice()), function (t) {
      return t.dataRef.current.domRef.current;
    }),
    s = r ? i.indexOf(r) : null;
  return s === -1 && (s = null), {
    items: i,
    activeItemIndex: s
  };
}
var Te = (_Te = {}, _defineProperty(_Te, 1, function _(e) {
    return e.menuState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      activeItemIndex: null,
      menuState: 1
    });
  }), _defineProperty(_Te, 0, function _(e) {
    return e.menuState === 0 ? e : _objectSpread(_objectSpread({}, e), {}, {
      __demoMode: !1,
      menuState: 0
    });
  }), _defineProperty(_Te, 2, function _(e, u) {
    var s;
    var r = w(e),
      i = Y(u, {
        resolveItems: function resolveItems() {
          return r.items;
        },
        resolveActiveIndex: function resolveActiveIndex() {
          return r.activeItemIndex;
        },
        resolveId: function resolveId(t) {
          return t.id;
        },
        resolveDisabled: function resolveDisabled(t) {
          return t.dataRef.current.disabled;
        }
      });
    return _objectSpread(_objectSpread(_objectSpread({}, e), r), {}, {
      searchQuery: "",
      activeItemIndex: i,
      activationTrigger: (s = u.trigger) != null ? s : 1
    });
  }), _defineProperty(_Te, 3, function _(e, u) {
    var i = e.searchQuery !== "" ? 0 : 1,
      s = e.searchQuery + u.value.toLowerCase(),
      o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + i).concat(e.items.slice(0, e.activeItemIndex + i)) : e.items).find(function (l) {
        var m;
        return ((m = l.dataRef.current.textValue) == null ? void 0 : m.startsWith(s)) && !l.dataRef.current.disabled;
      }),
      a = o ? e.items.indexOf(o) : -1;
    return a === -1 || a === e.activeItemIndex ? _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: s
    }) : _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: s,
      activeItemIndex: a,
      activationTrigger: 1
    });
  }), _defineProperty(_Te, 4, function _(e) {
    return e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: "",
      searchActiveItemIndex: null
    });
  }), _defineProperty(_Te, 5, function _(e, u) {
    var r = w(e, function (i) {
      return [].concat(_toConsumableArray(i), [{
        id: u.id,
        dataRef: u.dataRef
      }]);
    });
    return _objectSpread(_objectSpread({}, e), r);
  }), _defineProperty(_Te, 6, function _(e, u) {
    var r = w(e, function (i) {
      var s = i.findIndex(function (t) {
        return t.id === u.id;
      });
      return s !== -1 && i.splice(s, 1), i;
    });
    return _objectSpread(_objectSpread(_objectSpread({}, e), r), {}, {
      activationTrigger: 1
    });
  }), _Te),
  U = X(null);
U.displayName = "MenuContext";
function O(e) {
  var u = $(U);
  if (u === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Menu /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, O), r;
  }
  return u;
}
function ye(e, u) {
  return j(u.type, Te, e, u);
}
var Ie = N;
function Me(e, u) {
  var _j;
  var _e$__demoMode = e.__demoMode,
    r = _e$__demoMode === void 0 ? !1 : _e$__demoMode,
    i = _objectWithoutProperties(e, _excluded),
    s = z(ye, {
      __demoMode: r,
      menuState: r ? 0 : 1,
      buttonRef: H(),
      itemsRef: H(),
      items: [],
      searchQuery: "",
      activeItemIndex: null,
      activationTrigger: 1
    }),
    _s = _slicedToArray(s, 2),
    _s$ = _s[0],
    t = _s$.menuState,
    o = _s$.itemsRef,
    a = _s$.buttonRef,
    l = _s[1],
    m = F(u);
  oe([a, o], function (g, R) {
    var p;
    l({
      type: 1
    }), ee(R, te.Loose) || (g.preventDefault(), (p = a.current) == null || p.focus());
  }, t === 0);
  var I = d(function () {
      l({
        type: 1
      });
    }),
    A = x(function () {
      return {
        open: t === 0,
        close: I
      };
    }, [t, I]),
    f = {
      ref: m
    };
  return G.createElement(U.Provider, {
    value: s
  }, G.createElement(ie, {
    value: j(t, (_j = {}, _defineProperty(_j, 0, C.Open), _defineProperty(_j, 1, C.Closed), _j))
  }, D({
    ourProps: f,
    theirProps: i,
    slot: A,
    defaultTag: Ie,
    name: "Menu"
  })));
}
var ge = "button";
function Re(e, u) {
  var R;
  var r = k(),
    _e$id = e.id,
    i = _e$id === void 0 ? "headlessui-menu-button-".concat(r) : _e$id,
    s = _objectWithoutProperties(e, _excluded2),
    _O = O("Menu.Button"),
    _O2 = _slicedToArray(_O, 2),
    t = _O2[0],
    o = _O2[1],
    a = F(t.buttonRef, u),
    l = W(),
    m = d(function (p) {
      switch (p.key) {
        case c.Space:
        case c.Enter:
        case c.ArrowDown:
          p.preventDefault(), p.stopPropagation(), o({
            type: 0
          }), l.nextFrame(function () {
            return o({
              type: 2,
              focus: y.First
            });
          });
          break;
        case c.ArrowUp:
          p.preventDefault(), p.stopPropagation(), o({
            type: 0
          }), l.nextFrame(function () {
            return o({
              type: 2,
              focus: y.Last
            });
          });
          break;
      }
    }),
    I = d(function (p) {
      switch (p.key) {
        case c.Space:
          p.preventDefault();
          break;
      }
    }),
    A = d(function (p) {
      if (Z(p.currentTarget)) return p.preventDefault();
      e.disabled || (t.menuState === 0 ? (o({
        type: 1
      }), l.nextFrame(function () {
        var M;
        return (M = t.buttonRef.current) == null ? void 0 : M.focus({
          preventScroll: !0
        });
      })) : (p.preventDefault(), o({
        type: 0
      })));
    }),
    f = x(function () {
      return {
        open: t.menuState === 0
      };
    }, [t]),
    g = {
      ref: a,
      id: i,
      type: ue(e, t.buttonRef),
      "aria-haspopup": "menu",
      "aria-controls": (R = t.itemsRef.current) == null ? void 0 : R.id,
      "aria-expanded": t.menuState === 0,
      onKeyDown: m,
      onKeyUp: I,
      onClick: A
    };
  return D({
    ourProps: g,
    theirProps: s,
    slot: f,
    defaultTag: ge,
    name: "Menu.Button"
  });
}
var Ae = "div",
  be = Q.RenderStrategy | Q.Static;
function Ee(e, u) {
  var M, b;
  var r = k(),
    _e$id2 = e.id,
    i = _e$id2 === void 0 ? "headlessui-menu-items-".concat(r) : _e$id2,
    s = _objectWithoutProperties(e, _excluded3),
    _O3 = O("Menu.Items"),
    _O4 = _slicedToArray(_O3, 2),
    t = _O4[0],
    o = _O4[1],
    a = F(t.itemsRef, u),
    l = le(t.itemsRef),
    m = W(),
    I = se(),
    A = function () {
      return I !== null ? (I & C.Open) === C.Open : t.menuState === 0;
    }();
  q(function () {
    var n = t.itemsRef.current;
    n && t.menuState === 0 && n !== (l == null ? void 0 : l.activeElement) && n.focus({
      preventScroll: !0
    });
  }, [t.menuState, t.itemsRef, l]), ae({
    container: t.itemsRef.current,
    enabled: t.menuState === 0,
    accept: function accept(n) {
      return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(n) {
      n.setAttribute("role", "none");
    }
  });
  var f = d(function (n) {
      var E, P;
      switch (m.dispose(), n.key) {
        case c.Space:
          if (t.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), o({
            type: 3,
            value: n.key
          });
        case c.Enter:
          if (n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), t.activeItemIndex !== null) {
            var S = t.items[t.activeItemIndex].dataRef;
            (P = (E = S.current) == null ? void 0 : E.domRef.current) == null || P.click();
          }
          J(t.buttonRef.current);
          break;
        case c.ArrowDown:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.Next
          });
        case c.ArrowUp:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.Previous
          });
        case c.Home:
        case c.PageUp:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.First
          });
        case c.End:
        case c.PageDown:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.Last
          });
        case c.Escape:
          n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), _().nextFrame(function () {
            var S;
            return (S = t.buttonRef.current) == null ? void 0 : S.focus({
              preventScroll: !0
            });
          });
          break;
        case c.Tab:
          n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), _().nextFrame(function () {
            re(t.buttonRef.current, n.shiftKey ? V.Previous : V.Next);
          });
          break;
        default:
          n.key.length === 1 && (o({
            type: 3,
            value: n.key
          }), m.setTimeout(function () {
            return o({
              type: 4
            });
          }, 350));
          break;
      }
    }),
    g = d(function (n) {
      switch (n.key) {
        case c.Space:
          n.preventDefault();
          break;
      }
    }),
    R = x(function () {
      return {
        open: t.menuState === 0
      };
    }, [t]),
    p = {
      "aria-activedescendant": t.activeItemIndex === null || (M = t.items[t.activeItemIndex]) == null ? void 0 : M.id,
      "aria-labelledby": (b = t.buttonRef.current) == null ? void 0 : b.id,
      id: i,
      onKeyDown: f,
      onKeyUp: g,
      role: "menu",
      tabIndex: 0,
      ref: a
    };
  return D({
    ourProps: p,
    theirProps: s,
    slot: R,
    defaultTag: Ae,
    features: be,
    visible: A,
    name: "Menu.Items"
  });
}
var Se = N;
function Pe(e, u) {
  var r = k(),
    _e$id3 = e.id,
    i = _e$id3 === void 0 ? "headlessui-menu-item-".concat(r) : _e$id3,
    _e$disabled = e.disabled,
    s = _e$disabled === void 0 ? !1 : _e$disabled,
    t = _objectWithoutProperties(e, _excluded4),
    _O5 = O("Menu.Item"),
    _O6 = _slicedToArray(_O5, 2),
    o = _O6[0],
    a = _O6[1],
    l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === i : !1,
    m = K(null),
    I = F(u, m);
  L(function () {
    if (o.__demoMode || o.menuState !== 0 || !l || o.activationTrigger === 0) return;
    var T = _();
    return T.requestAnimationFrame(function () {
      var v, B;
      (B = (v = m.current) == null ? void 0 : v.scrollIntoView) == null || B.call(v, {
        block: "nearest"
      });
    }), T.dispose;
  }, [o.__demoMode, m, l, o.menuState, o.activationTrigger, o.activeItemIndex]);
  var A = ce(m),
    f = K({
      disabled: s,
      domRef: m,
      get textValue() {
        return A();
      }
    });
  L(function () {
    f.current.disabled = s;
  }, [f, s]), L(function () {
    return a({
      type: 5,
      id: i,
      dataRef: f
    }), function () {
      return a({
        type: 6,
        id: i
      });
    };
  }, [f, i]);
  var g = d(function () {
      a({
        type: 1
      });
    }),
    R = d(function (T) {
      if (s) return T.preventDefault();
      a({
        type: 1
      }), J(o.buttonRef.current);
    }),
    p = d(function () {
      if (s) return a({
        type: 2,
        focus: y.Nothing
      });
      a({
        type: 2,
        focus: y.Specific,
        id: i
      });
    }),
    M = pe(),
    b = d(function (T) {
      return M.update(T);
    }),
    n = d(function (T) {
      M.wasMoved(T) && (s || l || a({
        type: 2,
        focus: y.Specific,
        id: i,
        trigger: 0
      }));
    }),
    E = d(function (T) {
      M.wasMoved(T) && (s || l && a({
        type: 2,
        focus: y.Nothing
      }));
    }),
    P = x(function () {
      return {
        active: l,
        disabled: s,
        close: g
      };
    }, [l, s, g]);
  return D({
    ourProps: {
      id: i,
      ref: I,
      role: "menuitem",
      tabIndex: s === !0 ? void 0 : -1,
      "aria-disabled": s === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: R,
      onFocus: p,
      onPointerEnter: b,
      onMouseEnter: b,
      onPointerMove: n,
      onMouseMove: n,
      onPointerLeave: E,
      onMouseLeave: E
    },
    theirProps: t,
    slot: P,
    defaultTag: Se,
    name: "Menu.Item"
  });
}
var ve = h(Me),
  xe = h(Re),
  he = h(Ee),
  De = h(Pe),
  it = Object.assign(ve, {
    Button: xe,
    Items: he,
    Item: De
  });
export { it as Menu };